/**
 * @generated SignedSource<<45439ba28226a319e7b7069d0e660fb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetNoteEditingMode = "DEFAULT" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type WidgetNote_widgetNote$data = {
  readonly id: string;
  readonly note: {
    readonly editingMode: WidgetNoteEditingMode;
    readonly isOrgNote: boolean;
    readonly pages: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"NoteNative_note" | "NoteWeb_note">;
  };
  readonly " $fragmentType": "WidgetNote_widgetNote";
};
export type WidgetNote_widgetNote$key = {
  readonly " $data"?: WidgetNote_widgetNote$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNote_widgetNote",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "editingMode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOrgNote",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WidgetNotePage",
          "kind": "LinkedField",
          "name": "pages",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NoteWeb_note"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NoteNative_note"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetNote",
  "abstractKey": null
};
})();

(node as any).hash = "8ff42bf80304feac25b02025855191f3";

export default node;
